/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesUpdateBillingDetails } from '../../axios/profilesUpdateBillingDetails'
import type {
	ProfilesUpdateBillingDetailsError,
	ProfilesUpdateBillingDetailsPathParams,
	ProfilesUpdateBillingDetailsRequest,
	ProfilesUpdateBillingDetailsResponse,
} from '../../types/ProfilesUpdateBillingDetails'

export const profilesUpdateBillingDetailsMutationKey = () =>
	[{ url: '/:organisation/profiles/:profile/billing-details' }] as const

export type ProfilesUpdateBillingDetailsMutationKey = ReturnType<typeof profilesUpdateBillingDetailsMutationKey>

export type ProfilesUpdateBillingDetailsVariables = {
	organisation: ProfilesUpdateBillingDetailsPathParams['organisation']
	profile: ProfilesUpdateBillingDetailsPathParams['profile']
	data: ProfilesUpdateBillingDetailsRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::updateBillingDetails */
export function useProfilesUpdateBillingDetails<TContext = unknown>(
	options?: UseMutationOptions<
		ProfilesUpdateBillingDetailsResponse,
		AxiosError<ProfilesUpdateBillingDetailsError>,
		ProfilesUpdateBillingDetailsVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: profilesUpdateBillingDetailsMutationKey(),
		mutationFn: ({ organisation, profile, data }: ProfilesUpdateBillingDetailsVariables) =>
			profilesUpdateBillingDetails(organisation, profile, data, config).then(res => res.data),
		...options,
	})
}
